import { Stack, Typography, styled, type CSSObject } from '@mui/material';
import { Section, Testimonial } from '@rumblefish/ui/Rumblefish23Theme';
export const AdditionalInfoSection = styled(Section)(() => ({
  contain: 'paint',
  overflow: 'hidden',
}));

export const GlowStack = styled(Stack)(() => ({
  width: '70%',
  height: 'calc(70vw / 2)',
  borderRadius: '0 0 calc(70vw / 2) calc(70vw / 2)',
  position: 'absolute',
  transform: 'translateX(-50%) translateY(0%) translateZ(0)',
  zIndex: -1,
  left: '50%',
  background: 'rgba(255,255,255,0.06)',
  willChange: 'transform',
  filter: 'blur(200px)',
}));

export const StyledQuote = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontSize: '98px !important',
  lineHeight: '92px !important',
  height: '50px',
  [theme.breakpoints.up(800)]: {
    display: 'none',
  },
  width: 'min-content',
}));
export const TestimonialWrapper = styled(Stack)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('xl')]: {
    height: '424px',
  },
}));
export const StyledTypography = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  width: '50%',
  [theme.breakpoints.down('xl')]: {
    width: '51%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '55%',
  },
  [theme.breakpoints.down('md')]: {
    width: '68%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));
export const NameBannerStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down(800)]: {
    margin: theme.spacing(0, 0, 3, 0),
  },
}));
export const StyledStack = styled(Stack)(({ theme }) => ({
  position: 'relative',
  gap: theme.spacing(8),
  margin: theme.spacing(5, 0),
  [theme.breakpoints.down('lg')]: {
    margin: theme.spacing(16, 0, 10, 0),
  },
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(8, 0),
    gap: theme.spacing(3),
  },
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
    margin: theme.spacing(6, 0, 6, 0),
  },
}));

export const StyledTestimonial = styled(Testimonial)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    [theme.breakpoints.down('xl')]: {
      alignItems: 'center',
    },
    ['div:nth-of-type(1)']: {
      [theme.breakpoints.down('xl')]: {
        minWidth: 'auto',
        width: '310px',
        height: '310px',
      },
    },
    ['div:nth-of-type(2)']: {
      div: {
        width: 'auto',
        height: 'auto',
      },

      [theme.breakpoints.down('xl')]: {
        flex: 1,
        padding: theme.spacing(3, 14, 3, 26),
      },
    },
  },
  ['>div:nth-of-type(2)']: {
    minWidth: 'auto',
    maxWidth: 'none',
    padding: theme.spacing(4, 14, 0, 22),
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(5, 16, 3, 20),
    },

    [theme.breakpoints.down('md')]: {
      // padding: theme.spacing(4, 11, 4, 23),
      padding: theme.spacing(8, 16, 5, 20),
    },
    [theme.breakpoints.down(800)]: {
      padding: '0px',
    },
  },
}));
